// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__8uqP-","filesListContainer":"PosDisputesFiles_filesListContainer__1UY2g","filesButton":"PosDisputesFiles_filesButton__3otDN"};